import { useContext } from "react"
import { createCaller } from "react-outside-call"
import UserContext from "./UserContext/context"
import SidebarContext from "./SidebarContext/context"
import ModalContext from "./ModalContext/context"
import ToastContext from "./ToastContext/context"

const globalContext = createCaller({
  userContext: () => useContext(UserContext),
  sidebarContext: () => useContext(SidebarContext),
  modalContext: () => useContext(ModalContext),
  toastContext: () => useContext(ToastContext)
})

export default globalContext
